import u from '@/utility/utility';

export class BillOfLadingModel {
    public createdBy!: string;
    public createdDate!: string;
    public id!: number;
    public modifiedBy!: any;
    public modifiedDate!: any;
    public orderCodeId!: number;
    public orderId!: number;
    public transactionCode!: string;
    public productName!: string;
    public productAmount!: number;
    public numberOfPack!: number;
    public realNumberOfPack!: number;
    public productNumber!: number;
    public feeType!: any;
    public packageType!: any;
    public productType!: any;
    public status!: number;
    public exchangeRate!: number;
    public feeShip!: number;
    public feeShipVND!: number;
    public weightPrice!: number;
    public volumePrice!: number;
    public length!: number;
    public width!: number;
    public height!: number;
    public totalAmount!: number;
    public statusDetail!: any;
    public uId!: number;
    public userName!: string;
    public weight!: string;
    public weightByVolume!: string;
    public volume!: string;
}

export class Lading {
    public id: any = u.randomString(20);
    public binCode!: string;
    public productName!: string;
    public productAmount!: number;
    public numberOfPack!: number;
    public productNumber!: number;
    public isValid = true;
};